import {
    ADD_TO_CART, MINUS_TO_CART, CHANGEPOPSTATUS, SETSERVERCART, SET_MULTI_ORDER_POPUP_SHOWN, SET_VOUCHER_CODE, SETCARTERROR,
    SETPAYMENT, ORDERSUCESS, ORDERREDIRECT, FINALCARTRESPONSE, FINALSETTLE, REDIRECTORDER, SETORDERINSTRUCTIONS, SETVOUCHERSUCCESS,
    SETFINALCARTERROR
}
    from "../actionTypes";
import { createSelector } from 'reselect'

const cart = localStorage.getItem("cart");
const mainOrderId = localStorage.getItem("mainOrderId");

const initialState = {
    items: cart ? JSON.parse(cart) : [],
    isPopupOpen: false,
    serverCart: {},
    multiOrderPopupShown: false,
    voucherCode: "",
    error: "",
    payment: "cod",
    orderid: mainOrderId > 0 ? mainOrderId : 0,
    orderRedirect: false,
    finalCartResponse: { orders: [] },
    orderCount: 0,
    order_instruction: "",
    isVoucherApplied: false,
    finalCartError: ""
};

export default function (state = initialState, action) {
    switch (action.type) {
        case MINUS_TO_CART:
        case ADD_TO_CART: {
            return {
                ...state,
                items: [
                    ...action.payload
                ]
            }
        }
        case CHANGEPOPSTATUS: {
            return {
                ...state,
                isPopupOpen: action.payload
            }
        }
        case SETSERVERCART: {
            return {
                ...state,
                serverCart: action.payload
            }
        }
        case SET_MULTI_ORDER_POPUP_SHOWN: {
            return {
                ...state,
                multiOrderPopupShown: action.payload
            }
        }
        case SET_VOUCHER_CODE: {
            return {
                ...state,
                voucherCode: action.payload,
                error: "",
                isVoucherApplied: false
            }

        }

        case SETCARTERROR: {
            return {
                ...state,
                error: action.payload
            }
        }

        case SETPAYMENT: {
            return {
                ...state,
                payment: action.payload
            }
        }

        case ORDERREDIRECT: {
            return {
                ...state,
                orderRedirect: action.payload,
                items: [],
                order_instruction: "",

            }
        }

        case ORDERSUCESS: {
            return {
                ...state,
                orderid: action.payload,


            }
        }

        case FINALCARTRESPONSE: {
            return {
                ...state,
                finalCartResponse: action.payload
            }
        }

        case FINALSETTLE: {
            return {
                ...state,
                items: [],
                isPopupOpen: false,
                serverCart: {},
                multiOrderPopupShown: false,
                voucherCode: "",
                error: "",
                payment: "cod",
                orderRedirect: true,
                finalCartResponse: { orders: [] },
                isVoucherApplied: false
            }
        }

        case REDIRECTORDER: {
            return {
                ...state,
                orderid: 0,
                orderRedirect: false
            }
        }

        case SETORDERINSTRUCTIONS: {
            return {
                ...state,
                order_instruction: action.payload
            }
        }

        case SETVOUCHERSUCCESS: {
            return {
                ...state,
                isVoucherApplied: true

            }
        }
        case SETFINALCARTERROR: {
            return {
                ...state,
                finalCartError: action.payload

            }
        }
        default:
            return state;
    }
}


const cartItemsSelector = state => state.cart.items


const cartItemCountSelectorFactory = (state, item_id) => {
    let count = 0;
    if (state.cart.items.length > 0) {
        state.cart.items.forEach(element => {
            if (element.item_id == item_id) {
                count = count + element.qty;
            }
        });

    }

    return count;

}

export const isAddedSelector = createSelector(cartItemCountSelectorFactory, count => count);

export const subtotalSelector = createSelector(
    cartItemsSelector,
    items => items.reduce((acc, item) => acc + (item.subtotal * item.qty), 0)
)

export const totalCartCountSelector = createSelector(
    cartItemsSelector,
    items => items.reduce((acc, item) => acc + item.qty, 0)
)




export const isAddedSelector1 = (state, item_id) => {
    let count = 0;
    console.log(state.cart.items);
    if (state.cart.items.length > 0) {
        state.cart.items.forEach(element => {
            if (element.item_id == item_id) {
                count = count + element.qty;
            }
        });

    }
    if (count > 0)
        console.log(item_id, count);
    return count;
}


const allOrders = state => state.cart.finalCartResponse.orders

const allNotRejectedOrders = state => state.cart.finalCartResponse.orders.filter(order => order.status.toLowerCase() != 'rejected' && order.status.toLowerCase() != 'decline')



export const allOrdersTotalSelector = createSelector(
    allNotRejectedOrders,
    items => items.reduce((acc, item) => acc + item.gross_amount, 0).toFixed(2)
)

export const allOrdersCount = createSelector(
    allOrders,
    items => items.length
)


export const orderStatus = (status) => {
    switch (status.toLowerCase()) {
        case 'pending':
            return 'Your order has been placed';
            break;
        case 'accepted':
            return 'Your order is being prepared';
            break;
        case 'decline':
            return 'Your order rejected';
            break;
        case 'rejected':
            return 'Your order rejected';
            break;
        default:
            return 'Your order is being ready';
    }
}


